package team.platforma.multiplatform_material_extension.pie_chart

import androidx.compose.foundation.Canvas
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.aspectRatio
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.size
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.ProgressIndicatorDefaults
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.geometry.Rect
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PaintingStyle.Companion.Stroke
import androidx.compose.ui.graphics.StrokeCap
import androidx.compose.ui.graphics.drawscope.Stroke
import androidx.compose.ui.graphics.graphicsLayer
import androidx.compose.ui.unit.dp
import kotlin.math.PI
import kotlin.math.floor

@Composable
fun PieChart(
    completedPercent: Float=.3f, // 0.0 to 1.0
    modifier: Modifier = Modifier,
    completedColor: Color = Color(0xFF4CAF50),
    remainingColor: Color = Color(0xFFF44336),
    gapAngle: Float = 2f,
    strokeWidth: Float = 100f,
) {



    Canvas(modifier = Modifier.size(200.dp)) {
        val sweepAngleCompleted = 360 * completedPercent
        val sweepAngleRemaining = 360 - sweepAngleCompleted

        val diameter = size.minDimension
        val radius = diameter / 2
        val padding = strokeWidth / 2
        val rect = Rect(
            left = padding,
            top = padding,
            right = diameter - padding,
            bottom = diameter - padding
        )

        val startAngle = -90f

        //выполнено
        drawArc(
            color = completedColor,
            startAngle = startAngle,
            sweepAngle = sweepAngleCompleted,
            useCenter = false,
            style = Stroke(width = strokeWidth),
            size = rect.size,
            topLeft = rect.topLeft
        )
        //не выполнено
        drawArc(
            color = remainingColor,
            startAngle = startAngle + sweepAngleCompleted + gapAngle,
            sweepAngle = sweepAngleRemaining - (gapAngle * 2),
            useCenter = false,
            style = Stroke(width = strokeWidth),
            size = rect.size,
            topLeft = rect.topLeft
        )
    }
}

@Composable
fun PieChart3(
    completedPercent: Float = 0.5f, // от 0.0 до 1.0
    modifier: Modifier = Modifier,
    completedColor: Color = Color(0xFF4CAF50),
    remainingColor: Color = Color(0xFFF44336),
    gapAngle: Float = 4f // угол между сегментами в градусах
) {
    Canvas(modifier = modifier.size(200.dp)) {
        // Рассчитываем дуги с учётом зазора
        val totalAngle = 360f - gapAngle
        val completedAngle = totalAngle * completedPercent
        val remainingAngle = totalAngle - completedAngle

        val startAngleCompleted = -90f
        val startAngleRemaining = startAngleCompleted + completedAngle + gapAngle


        drawArc(
            color = completedColor,
            startAngle = startAngleCompleted,
            sweepAngle = completedAngle,
            useCenter = true,
            size = size
        )


        drawArc(
            color = remainingColor,
            startAngle = startAngleRemaining,
            sweepAngle = remainingAngle,
            useCenter = true,
            size = size
        )
    }
}


@Composable
fun PieChart4(
    completedPercent: Float = 0.5f, // от 0.0 до 1.0
    modifier: Modifier = Modifier,
    completedColor: Color = Color(0xFF4CAF50),
    remainingColor: Color = Color(0xFFF44336),
    gapAngle: Float = 6f // угол отступа только у "не выполнено"
) {
    Canvas(modifier = modifier.size(200.dp)) {
        val completedAngle = 360f * completedPercent
        val remainingAngle = 360f * (1f - completedPercent) - gapAngle

        val startAngleCompleted = -90f
        val startAngleRemaining = -90f + completedAngle + gapAngle

        // ✅ выполнено — без отступа
        drawArc(
            color = completedColor,
            startAngle = startAngleCompleted,
            sweepAngle = completedAngle,
            useCenter = true,
            size = size
        )

        // ❌ не выполнено — с отступом
        drawArc(
            color = remainingColor,
            startAngle = startAngleRemaining,
            sweepAngle = remainingAngle.coerceAtLeast(0f), // защита от отрицательных углов
            useCenter = true,
            size = size
        )
    }
}

@Composable
fun PieChart2(
    completedPercent: Float = 1f, // от 0.0 до 1.0
    modifier: Modifier = Modifier,
    completedColor: Color = Color(0xFF4CAF50),
    remainingColor: Color = Color(0xFFF44336),
    strokeWidth: Float = 100f,
    gapDegrees: Float? = null,
    angleOffset: Float = 0.5f // 👉 Небольшой сдвиг, чтобы убрать перекрытие
) {
    Canvas(modifier = modifier.size(200.dp)) {
        val diameter = size.minDimension
        val radius = diameter / 2
        val padding = strokeWidth / 2
        val rect = Rect(
            left = padding,
            top = padding,
            right = diameter - padding,
            bottom = diameter - padding
        )

        // Расчёт угла визуального зазора
        val capExtension = strokeWidth / 2
        val visualGapAngle = gapDegrees ?: (capExtension / (2 * PI * radius) * 360).toFloat()

        val totalSweep = 360f - visualGapAngle
        val sweepAngleCompleted = totalSweep * completedPercent
        val sweepAngleRemaining = totalSweep - sweepAngleCompleted

        val startAngleCompleted = -90f + angleOffset
        val startAngleRemaining = startAngleCompleted + sweepAngleCompleted + visualGapAngle

        // ✅ Выполнено
        drawArc(
            color = completedColor,
            startAngle = startAngleCompleted,
            sweepAngle = sweepAngleCompleted,
            useCenter = false,
            style = Stroke(width = strokeWidth),
            size = rect.size,
            topLeft = rect.topLeft
        )

        // ❌ Не выполнено
        drawArc(
            color = remainingColor,
            startAngle = startAngleRemaining,
            sweepAngle = sweepAngleRemaining,
            useCenter = false,
            style = Stroke(width = strokeWidth),
            size = rect.size,
            topLeft = rect.topLeft
        )
    }
}

@Composable
fun PieChart6(
    completedPercent: Float
) {
    Box(
        modifier = Modifier.size(200.dp)
    ) {
        CircularProgressIndicator(
            modifier = Modifier.fillMaxSize().graphicsLayer {
                                                            rotationZ = 180f
            },
            progress = { completedPercent },
            strokeWidth = 24.dp,
            strokeCap = StrokeCap.Butt,
        )

        val percentValue = completedPercent * 100
        val isWholeNumber = floor(percentValue) == percentValue

        val percentText = if (isWholeNumber) {
            percentValue.toInt().toString()
        } else {
            (kotlin.math.round(percentValue * 10) / 10).toString()
        }

        Text(
            modifier = Modifier.align(Alignment.Center),
            text = "$percentText%"
        )
    }

}